import { api } from "./api";
import { ShipmentType } from "../types/Shipment";
import { shipmentEndpoints } from "../constants/endpoints";
import { getApiOrganizationId } from "../utils/orgIdUtils";
import { mapOrderStatus } from "../utils/orderMapping";

export const fetchShipmentListingData = async (
  page = 1,
  limit = 10,
  search = ""
): Promise<{ data: ShipmentType[]; totalRecords: number }> => {
  try {
    const response = await api.get(shipmentEndpoints.getOrderByStatus, {
      params: {
        page,
        limit,
        search,
      },
      headers: {
        orgId: getApiOrganizationId(),
      },
    });

    const { orders, pagination } = response.data.data;

    const shipmentData: ShipmentType[] = orders.map((order: any) => ({
      shipmentId: order.Shipment?.shipmentId,
      customer: order.customer?.outletName || "Unknown",
      location: order.customer?.Address?.registeredAddress || "Unknown",
      orderDetails: {
        orderId: order.id,
        OrderName: order.number,
        price: `₹ ${order.totalAmountInCents / 100}`,
      },
      payment:
        order.paymentStatus === "SUCCESS" ? "DONE" : order.paymentStatus || "-",
      ETA: order.eta
        ? new Date(order.eta).toLocaleDateString("en-GB", { timeZone: "UTC" })
        : "-",
      orderStatus: order.orderStatus
        ? mapOrderStatus(order.orderStatus)
        : "Ready for Dispatch",
      truckNo: order.Shipment?.truckNumber || "",
      driverName: order.Shipment?.driverName || "",
      phone: order.Shipment?.phoneNumber || "",
    }));

    return {
      data: shipmentData,
      totalRecords: pagination.totalRecords,
    };
  } catch (error: any) {
    console.error("Error fetching shipment data:", {
      message: error.message,
      response: error.response?.data,
    });
    throw new Error("Failed to fetch shipment data from the backend.");
  }
};

export const updateShipments = async (
  shipments: ShipmentType[]
): Promise<void> => {
  try {
    if (!Array.isArray(shipments) || shipments.length === 0) {
      throw new Error("Payload must be a non-empty array of shipments.");
    }

    const payload = shipments.map((shipment) => ({
      shipmentId: shipment.shipmentId,
      orderId: shipment.orderDetails.orderId,
      trackingNumber: "TRACK-987654",
      truckNumber: shipment.truckNo,
      driverName: shipment.driverName,
      phoneNumber: shipment.phone,
    }));

    const response = await api.put(shipmentEndpoints.updateShipment, payload, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });

    console.log("Shipments updated successfully:", response.data);
  } catch (error: any) {
    console.error("Error updating shipments:", {
      message: error.message,
      response: error.response?.data,
    });
    throw new Error(
      error.response?.data?.message || "Failed to update shipments"
    );
  }
};
